import { parseJson } from '@flowio/web-sdk';

const assign = require('lodash/assign');
const get = require('lodash/get');
const omit = require('lodash/omit');
const session = require('@flowio/session');
const SessionClient = require('@flowio/session/lib/client');
const persistSession = require('@flowio/session/lib/persist-session');
const optionsSuccess = require('./utilities/options-success');
const optionsError = require('./utilities/options-error');

const config = require('./config');

const sessionClient = new SessionClient({ apiBaseUri: config.API_BASE_URI });

function setConsumerId(options = {}) {
  const consumerIdElement = document.querySelector('[flow-consumer-id]');
  const consumerIdAttribute = consumerIdElement && parseJson(consumerIdElement.getAttribute('value'));
  const consumerId = get(consumerIdAttribute, 'flow_consumer_id');
  const sessionId = session.getSessionId();
  const geo = session.getGeo();
  const experience = session.getExperience();
  const previousAttributes = session.getAttributes();
  const previousConsumerId = get(previousAttributes, 'flow_consumer_id');

  function handleSuccess(updatedSession) {
    persistSession(updatedSession);
    optionsSuccess(options, updatedSession);
  }

  function handleError(error) {
    optionsError(options, `'Could not update session with flow consumer id: ${error.message}`);
  }

  if (consumerId != null) {
    if (consumerId !== previousConsumerId) {
      sessionClient.resetSession({
        geo,
        experience,
        integration: 'shopify',
        attributes: assign({}, previousAttributes, consumerIdAttribute),
        sessionId,
        onSuccess: handleSuccess,
        onError: handleError,
      });
    }
  } else if (previousConsumerId != null) {
    sessionClient.resetSession({
      geo,
      experience,
      integration: 'shopify',
      attributes: omit(previousAttributes, ['flow_consumer_id']),
      sessionId,
      onSuccess: handleSuccess,
      onError: handleError,
    });
  }
}

module.exports = setConsumerId;



// WEBPACK FOOTER //
// ./static/js/v0/set-consumer-id.js